import Vue from 'vue'
Vue.config.productionTip = false;
Vue.config.devtools = false;
import contactItem from './views/_components/contact_item';
import fieldEntity from "./views/_components/entity_field";
import fieldHiBox from "./views/_components/hibox_field";
import fieldPassword from "./views/_components/password_visibility_field";
import fieldImageUpload from "./views/_components/img_upload_field";
import fieldCountry from "./views/_components/country_field";
import fieldSport from "./views/_components/sport_field";
import VueMoment from "vue-moment";
import VueFormGenerator from 'vue-form-generator'
import VfgFieldMatrix from 'vfg-field-matrix'
import VfgFieldObject from 'vfg-field-object'
import VfgFieldArray from 'vfg-field-array'
import VueFormWizard from "vue-form-wizard";
import VueSweetalert2 from 'vue-sweetalert2';
import VModal from 'vue-js-modal'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
Vue.use(VueVirtualScroller)
// import RouterTab from 'vue-router-tab'
import VuePromiseBtn from 'vue-promise-btn'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import 'vue-router-tab/dist/lib/vue-router-tab.css'
import 'vue-promise-btn/dist/vue-promise-btn.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import App from './App.vue'
import router from './router'
import './assets/style.css'
import hiPlugin from 'morpheos.hisport.vueplugin';
import store from 'morpheos.hisport.vueplugin/store'
import hiSpecific from 'morpheos.hisport.vueplugin/hisport-specific-web';
import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faGlobe, faEnvelope, faPhone, faPlus, faTrashAlt, 
  faEdit, faAngleLeft, faAngleRight, faFilter, faFutbol, 
  faExclamationTriangle, faPencilAlt, faTimes, faSave, 
  faTrash, faTasks, faDownload, faMedal, faKey, faSignOutAlt, 
  faRadiationAlt, faPlay, faPause, faStop, faPaintBrush, faCircle,
  faSquare, faPalette, faImage, faMapPin, faTag, faRoute, 
  faUndoAlt, faRedoAlt, faCheck, faInfoCircle, faQuestionCircle,
  faCheckDouble, faLink, faUnlink, faExternalLinkSquareAlt,
  faHatWizard,faSearchLocation,faEye,faEyeSlash,faList, 
  faSearch, faSearchPlus, faSearchMinus, faPowerOff,faVideo,
  faPrint, faExternalLinkAlt, faUpload, faSyncAlt,faStar,faBell,
  faPlug, faRobot, faMagic, faQuestion, faClipboard,faCalendar,
  faExpand, faCompress, faBroadcastTower,faRecordVinyl, faStopwatch,
  faCalendarCheck, faQrcode} from '@fortawesome/free-solid-svg-icons'
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons"
library.add(faGlobe, faEnvelope, faPhone, faPlus, faTrashAlt, 
            faEdit, faAngleLeft, faAngleRight, faFilter, faFutbol, 
            faExclamationTriangle, faPencilAlt, faTimes, faSave, 
            faTrash, faTasks, faDownload, faMedal, faKey, faSignOutAlt, 
            faRadiationAlt, faPlay, faPause, faStop, faPaintBrush, faCircle,
            faSquare, faPalette, faImage, faMapPin, faTag, faRoute, 
            faUndoAlt, faRedoAlt, faCheck, faInfoCircle, faQuestionCircle,
            faCheckDouble, faLink, faUnlink, faExternalLinkSquareAlt,
            faHatWizard,faSearchLocation,faEye,faEyeSlash,faList, 
            faSearch, faSearchPlus, faSearchMinus, faPowerOff,faVideo,
            faPrint, faExternalLinkAlt, faUpload, faSyncAlt, 
            faStar,faBell,faPlug,faRobot,faMagic, faQuestion, faClipboard,
            faCalendar,faExpand,faCompress, faBroadcastTower, faRecordVinyl,
            faWhatsapp, faStopwatch, faCalendarCheck, faQrcode)
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fab)
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
const moment = require('moment');
require('moment/locale/it');
import VueImgFallback from "v-img-fallback";
// import process from "process";
var _tryParse = function(x){
  try{
    return JSON.parse(x);
  }catch(ex){
    return {}
  }
}
const platform  = _tryParse(process.env.VUE_APP_PLATFORM);
const meta      = _tryParse(process.env.VUE_APP_META);

Vue.use(VueImgFallback, {
  loading: platform.public_logo_url,
  error: "/images/img_placeholder.svg"
})


import LabelsIT from "./it.i18n.json";
import LabelsEN from "./en.i18n.json";
import LabelsES from "./es.i18n.json";
Vue.component('v-select',           vSelect);
Vue.component('font-awesome-icon',  FontAwesomeIcon);
Vue.component('contact-item',       contactItem);
Vue.component("fieldEntity",        fieldEntity);
Vue.component("fieldHiBox",         fieldHiBox);
Vue.component("fieldPassword",      fieldPassword);
Vue.component("fieldImageUpload",   fieldImageUpload);
Vue.component("fieldCountry",       fieldCountry);
Vue.component("fieldSport",         fieldSport)

Vue.use(VuePromiseBtn); 
// Vue.use(RouterTab);
Vue.use(VueFormWizard);
Vue.use(VueFormGenerator);
Vue.use(VfgFieldMatrix);
Vue.use(VfgFieldObject);
Vue.use(VfgFieldArray);
Vue.use(VueSweetalert2);
Vue.use(VModal);
Vue.use(VueMoment, {moment});

var version = require("../package.json").version;
var labels = {it: LabelsIT, en: LabelsEN, es: LabelsES};
import { ENUMS } from "morpheos.hisport.vueplugin"
var assets = {
  imgFallback:{
    loading: platform.public_logo_url,
    error: "/images/img_placeholder.svg"
  },
  defaults: {
    [ENUMS.ENTITIES.ROOT_ENTITY]:       platform.public_logo_url,
    [ENUMS.ENTITIES.DISTRIBUTOR]:       require("./assets/menu_icons/distributors.svg"),
    [ENUMS.ENTITIES.STRUCTURE]:         require("./assets/menu_icons/structures.svg"),
    [ENUMS.ENTITIES.GAME_FIELD]:        require("./assets/menu_icons/game_fields.svg"),
    [ENUMS.ENTITIES.CLUB]:              require("./assets/menu_icons/clubs.svg"),
    [ENUMS.ENTITIES.TEAM]:              require("./assets/menu_icons/teams.svg"),
    [ENUMS.ENTITIES.USER]:              require("./assets/menu_icons/users.svg")
  }
};
var options = {
  culture_default:  "it",
  image: document.location.origin + platform.public_logo_url,
  meta,
  platform,
  version,
  labels,
  assets,
  router,
  onReady: function($hisport){
    Vue.filter('sec2time', function (value, short) {
        return $hisport.options.helpers.sec2time(value, short);
    });
    Vue.directive('i18n', function (el, binding) {
        el.innerHTML = $hisport.i18n(binding.value, binding.default);
    });
    Vue.filter("eventTitle", function(value, html, logo){
        return $hisport.eventTitle(value, {html, logo})
    })
    Vue.directive('hgEventTitle', function (el, binding) {
        if(!binding.value){
            console.error("hgEventTitle: NO BINDING", binding);
            return;
        }
        el.innerHTML = $hisport.eventTitle(binding.value.event, {html: binding.value.html, logo: binding.value.logo});
    });
    Vue.filter('i18n', function (value, def) {
        return  $hisport.i18n(value, def);
    });
    Vue.directive('validate', {
        bind: function(el,binding,vnode){
            Vue.nextTick(function(){
                var parent = vnode.elm.parentElement;
                var span = document.createElement("SPAN");
                span.classList.add("bubble");
                span.style.display = "none";
                parent.appendChild(span);
                var input = (el.nodeName == "INPUT" || el.childElementCount == 0)?el:el.querySelector("input");
                if(!input) input = el;
                var handler = function(){
                    if(binding && binding.value){
                        if(binding.value.equals){
                            var to_confirm = input;
                            var to_equal = document.querySelector(binding.value.equals);
                            console.log("EVALUATING EQUALS between", to_confirm, "and", to_equal, to_confirm.value != to_equal.value);
                            if(to_confirm.value != to_equal.value)
                                input.setCustomValidity('V_NO_PASSWORDS_MATCH');
                            else
                                input.setCustomValidity('');
                        }

                        if(binding.value.pwd) {
                            var filtered = $hisport.getPasswordRules()
                                .filter(function(r) {return !r.regex.test(
                                    document.querySelector(binding.value.pwd).value)
                                });
                            console.log("EVALUATING PWD => ", filtered == undefined || !filtered.length ? '' : filtered[0].message);
                            input.setCustomValidity(
                                filtered == undefined || !filtered.length ? '' : filtered[0].message);
                        }

                        if(binding.value.username) {
                            if($hisport.hasErrors(document.querySelector(binding.value.username).value))
                                input.setCustomValidity('V_TYPE_MISMATCH');
                            else 
                                input.setCustomValidity('');
                        }

                        if(binding.value.fn){
                            if(typeof binding.value.fn != "function"){
                                console.error("INVALID TYPE fn must be a function")
                            }else{
                                if(binding.value.fn.apply(el))
                                    input.setCustomValidity('');
                                else
                                    input.setCustomValidity('V_NO_VALID_VALUE');
                            }
                        }
                    }
                    var parent = vnode.elm.parentElement;
                    var span = parent.querySelector(".bubble")
                    if(input && input.validity && !input.validity.valid){
                        span.style.display = "inline";
                        var error = input.validationMessage;
                        if(input.validity.badInput)
                            error = "V_BAD_INPUT";
                        // else if(input.validity.customError)
                        //     error = "CUSTOM_ERROR";
                        else if(input.validity.patternMismatch)
                            error = "V_PATTERN_MISMATCH";
                        else if(input.validity.rangeOverflow)
                            error = "V_RANGE_OVERFLOW";
                        else if(input.validity.rangeUnderflow)
                            error = "V_RANGE_UNDERFLOW";
                        else if(input.validity.stepMismatch)
                            error = "V_STEP_MISMATCH";
                        else if(input.validity.tooLong)
                            error = "V_TOO_LONG";
                        else if(input.validity.tooShort)
                            error = "V_TOO_SHORT";
                        else if(input.validity.typeMismatch)
                            error = "V_TYPE_MISMATCH";
                        else if(input.validity.valueMissing)
                            error = "V_VALUE_MISSING";
                        span.innerHTML = $hisport.i18n(error, error);
                        el.classList.add("hg-error");
                    }else{
                        span.style.display = "none";
                        el.classList.remove("hg-error");
                    }
                }
                el.addEventListener('input', handler);
                el.addEventListener('change', handler);
                el.addEventListener('click', handler);
                el.addEventListener('focus', handler);
                el.addEventListener('blur', handler);

                if(binding && binding.value && binding.value.immediately)
                    handler()
            });
        }
    });
    Vue.mixin({
        created() {
            this.getTitle(this)
        },
        updated() {
            this.getTitle(this)
        },
        methods: {
            getTitle(vm) {
                const { title } = vm.$options
                if (title) {
                    var _title = typeof title === 'function'
                        ? title.call(vm)
                        : title
                    if (_title) {
                        document.title = $hisport.i18n(_title) + " | " + platform.name
                    }
                }
            }
        }
    })
    window.$hisport = $hisport
  }
}
for(var k in hiSpecific)
  options[k] = hiSpecific[k];

if(window.URLSearchParams){
  var searchParams = new URLSearchParams(window.location.search);
  if(searchParams.has("server.url")){
    options.url = searchParams.get("server.url");
    if(options.url.endsWith("/")) options.url = options.url.substring(0, options.url.length - 1)
  }
  if(searchParams.has("server.videoservice_url")){
    options.videoservice_url = searchParams.get("server.videoservice_url")
  }
}
Vue.use(hiPlugin, options);


new Vue({
  router,
  store,
  mounted(){
    var pw = document.querySelector("#preloader-wrapper");
    pw.style.display = 'block';
    var ld = document.querySelector("#loading");
    ld.style.opacity = 0;
  },
  render: h => h(App)
}).$mount('#app');
